import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import App from './App';
import * as serviceWorker from './serviceWorker';
import log from '@hrtps/log';
import tenant from 'libs/tenant';

log.init({
  env: process.env.REACT_APP_ENV as string,
  tenantId: tenant.getTenantId(),
  serviceCode: 'AI-COACH-ADMIN',
  getCustomizeContent: () => {
    // 非必填，
    // 该方法会在每次打点的时候执行，一般用于返回公共参数，如用户信息等，
    // 返回的参数每次打点都会携带在content.customizeContent中
    // 例：return {username: getUserName()}
  }
});

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();
